import { render, staticRenderFns } from "./CheeersCoinIcon.vue?vue&type=template&id=15bc5514&scoped=true&"
import script from "./CheeersCoinIcon.vue?vue&type=script&lang=ts&"
export * from "./CheeersCoinIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc5514",
  null
  
)

export default component.exports